import { render, staticRenderFns } from "./IconCopy.vue?vue&type=template&id=99a37386&scoped=true"
import script from "./IconCopy.vue?vue&type=script&lang=js"
export * from "./IconCopy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99a37386",
  null
  
)

export default component.exports